import ENV from "config/Env";
import { useTypedMutation } from "hooks";
import { ApiInstance } from "utils/Api";

type UploadCompanyStampPayload = {
  path: string;
  file: File;
};

export const useUploadCompanyStampMutation = () =>
  useTypedMutation<UploadCompanyStampPayload, string>({
    mutationFn: async ({ path, file }) => {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("path", path);

      return (await ApiInstance.post("/locations/upload/company_stamp", formData, ENV.dealerBaseURL)).data.url;
    },
    onSuccess: () => null
  });
